exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-container[data-v-393b9aaa]{width:23px;height:23px}@media screen and (min-width:768px){.img-container[data-v-393b9aaa]{width:40px;height:40px}}.img-container img[data-v-393b9aaa]{width:23px;height:23px}@media screen and (min-width:768px){.img-container img[data-v-393b9aaa]{width:40px;height:40px}}.img-container span[data-v-393b9aaa]{top:11px;left:14px;font-size:9px;font-weight:700}@media screen and (min-width:768px){.img-container span[data-v-393b9aaa]{font-size:14px;top:19px;left:25px}}", ""]);

// exports
